"use strict";
// @generated by Peggy 4.2.0.
//
// https://peggyjs.org/
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartRules = void 0;
exports.SyntaxError = peg$SyntaxError;
exports.parse = peg$parse;
function peg$subclass(child, parent) {
    function C() { this.constructor = child; }
    C.prototype = parent.prototype;
    child.prototype = new C();
}
function peg$SyntaxError(message, expected, found, location) {
    var self = Error.call(this, message);
    // istanbul ignore next Check is a necessary evil to support older environments
    if (Object.setPrototypeOf) {
        Object.setPrototypeOf(self, peg$SyntaxError.prototype);
    }
    self.expected = expected;
    self.found = found;
    self.location = location;
    self.name = "SyntaxError";
    return self;
}
peg$subclass(peg$SyntaxError, Error);
function peg$padEnd(str, targetLength, padString) {
    padString = padString || " ";
    if (str.length > targetLength) {
        return str;
    }
    targetLength -= str.length;
    padString += padString.repeat(targetLength);
    return str + padString.slice(0, targetLength);
}
peg$SyntaxError.prototype.format = function (sources) {
    var str = "Error: " + this.message;
    if (this.location) {
        var src = null;
        var k;
        for (k = 0; k < sources.length; k++) {
            if (sources[k].source === this.location.source) {
                src = sources[k].text.split(/\r\n|\n|\r/g);
                break;
            }
        }
        var s = this.location.start;
        var offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
            ? this.location.source.offset(s)
            : s;
        var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
        if (src) {
            var e = this.location.end;
            var filler = peg$padEnd("", offset_s.line.toString().length, ' ');
            var line = src[s.line - 1];
            var last = s.line === e.line ? e.column : line.length + 1;
            var hatLen = (last - s.column) || 1;
            str += "\n --> " + loc + "\n"
                + filler + " |\n"
                + offset_s.line + " | " + line + "\n"
                + filler + " | " + peg$padEnd("", s.column - 1, ' ')
                + peg$padEnd("", hatLen, "^");
        }
        else {
            str += "\n at " + loc;
        }
    }
    return str;
};
peg$SyntaxError.buildMessage = function (expected, found) {
    var DESCRIBE_EXPECTATION_FNS = {
        literal: function (expectation) {
            return "\"" + literalEscape(expectation.text) + "\"";
        },
        class: function (expectation) {
            var escapedParts = expectation.parts.map(function (part) {
                return Array.isArray(part)
                    ? classEscape(part[0]) + "-" + classEscape(part[1])
                    : classEscape(part);
            });
            return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
        },
        any: function () {
            return "any character";
        },
        end: function () {
            return "end of input";
        },
        other: function (expectation) {
            return expectation.description;
        }
    };
    function hex(ch) {
        return ch.charCodeAt(0).toString(16).toUpperCase();
    }
    function literalEscape(s) {
        return s
            .replace(/\\/g, "\\\\")
            .replace(/"/g, "\\\"")
            .replace(/\0/g, "\\0")
            .replace(/\t/g, "\\t")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
            .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
    }
    function classEscape(s) {
        return s
            .replace(/\\/g, "\\\\")
            .replace(/\]/g, "\\]")
            .replace(/\^/g, "\\^")
            .replace(/-/g, "\\-")
            .replace(/\0/g, "\\0")
            .replace(/\t/g, "\\t")
            .replace(/\n/g, "\\n")
            .replace(/\r/g, "\\r")
            .replace(/[\x00-\x0F]/g, function (ch) { return "\\x0" + hex(ch); })
            .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) { return "\\x" + hex(ch); });
    }
    function describeExpectation(expectation) {
        return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }
    function describeExpected(expected) {
        var descriptions = expected.map(describeExpectation);
        var i, j;
        descriptions.sort();
        if (descriptions.length > 0) {
            for (i = 1, j = 1; i < descriptions.length; i++) {
                if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
            }
            descriptions.length = j;
        }
        switch (descriptions.length) {
            case 1:
                return descriptions[0];
            case 2:
                return descriptions[0] + " or " + descriptions[1];
            default:
                return descriptions.slice(0, -1).join(", ")
                    + ", or "
                    + descriptions[descriptions.length - 1];
        }
    }
    function describeFound(found) {
        return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }
    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function peg$parse(input, options) {
    options = options !== undefined ? options : {};
    var peg$FAILED = {};
    var peg$source = options.grammarSource;
    var peg$startRuleFunctions = { Formula: peg$parseFormula };
    var peg$startRuleFunction = peg$parseFormula;
    var peg$c0 = "=";
    var peg$c1 = "or";
    var peg$c2 = "and";
    var peg$c3 = "not";
    var peg$c4 = "(";
    var peg$c5 = ")";
    var peg$c6 = "<>";
    var peg$c7 = ">=";
    var peg$c8 = "<=";
    var peg$c9 = "^";
    var peg$c10 = "-";
    var peg$c11 = "if";
    var peg$c12 = ",";
    var peg$c13 = "countif";
    var peg$c14 = "date_trunc";
    var peg$c15 = "date_diff";
    var peg$c16 = "order";
    var peg$c17 = "by";
    var peg$c18 = "asc";
    var peg$c19 = "desc";
    var peg$c20 = "partition";
    var peg$c21 = ".";
    var peg$c22 = "\"";
    var peg$c23 = "'";
    var peg$c24 = "true";
    var peg$c25 = "false";
    var peg$r0 = /^[<->]/;
    var peg$r1 = /^[+\-]/;
    var peg$r2 = /^[%*\/]/;
    var peg$r3 = /^[A-Za-z_]/;
    var peg$r4 = /^[A-Za-z0-9_]/;
    var peg$r5 = /^[0-9]/;
    var peg$r6 = /^[^"]/;
    var peg$r7 = /^[^']/;
    var peg$r8 = /^[ \t\n\r]/;
    var peg$e0 = peg$literalExpectation("=", false);
    var peg$e1 = peg$literalExpectation("OR", true);
    var peg$e2 = peg$literalExpectation("AND", true);
    var peg$e3 = peg$literalExpectation("NOT", true);
    var peg$e4 = peg$literalExpectation("(", false);
    var peg$e5 = peg$literalExpectation(")", false);
    var peg$e6 = peg$literalExpectation("<>", false);
    var peg$e7 = peg$literalExpectation(">=", false);
    var peg$e8 = peg$literalExpectation("<=", false);
    var peg$e9 = peg$classExpectation([["<", ">"]], false, false);
    var peg$e10 = peg$classExpectation(["+", "-"], false, false);
    var peg$e11 = peg$classExpectation(["%", "*", "/"], false, false);
    var peg$e12 = peg$literalExpectation("^", false);
    var peg$e13 = peg$literalExpectation("-", false);
    var peg$e14 = peg$literalExpectation("IF", true);
    var peg$e15 = peg$literalExpectation(",", false);
    var peg$e16 = peg$literalExpectation("COUNTIF", true);
    var peg$e17 = peg$literalExpectation("DATE_TRUNC", true);
    var peg$e18 = peg$literalExpectation("DATE_DIFF", true);
    var peg$e19 = peg$literalExpectation("ORDER", true);
    var peg$e20 = peg$literalExpectation("BY", true);
    var peg$e21 = peg$literalExpectation("ASC", true);
    var peg$e22 = peg$literalExpectation("DESC", true);
    var peg$e23 = peg$literalExpectation("PARTITION", true);
    var peg$e24 = peg$classExpectation([["A", "Z"], ["a", "z"], "_"], false, false);
    var peg$e25 = peg$classExpectation([["A", "Z"], ["a", "z"], ["0", "9"], "_"], false, false);
    var peg$e26 = peg$classExpectation([["0", "9"]], false, false);
    var peg$e27 = peg$literalExpectation(".", false);
    var peg$e28 = peg$literalExpectation("\"", false);
    var peg$e29 = peg$classExpectation(["\""], true, false);
    var peg$e30 = peg$literalExpectation("'", false);
    var peg$e31 = peg$classExpectation(["'"], true, false);
    var peg$e32 = peg$literalExpectation("TRUE", true);
    var peg$e33 = peg$literalExpectation("FALSE", true);
    var peg$e34 = peg$otherExpectation("whitespace");
    var peg$e35 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false);
    var peg$f0 = function (expr) { return expr; };
    var peg$f1 = function (head, tail) {
        return tail.reduce((left, [, , , right]) => ({
            type: "Logical", op: "OR", left, right
        }), head);
    };
    var peg$f2 = function (head, tail) {
        return tail.reduce((left, [, , , right]) => ({
            type: "Logical", op: "AND", left, right
        }), head);
    };
    var peg$f3 = function (operand) {
        return { type: "UnaryOp", op: "NOT", operand };
    };
    var peg$f4 = function (expr) { return expr; };
    var peg$f5 = function (left, op, right) {
        return { type: "Comparison", op, left, right };
    };
    var peg$f6 = function (name) { return booleanFns.includes(name.toUpperCase()); };
    var peg$f7 = function (name, arg) {
        return { type: "SingleArgFn", name: name.toUpperCase(), arg };
    };
    var peg$f8 = function (head, tail) {
        return tail.reduce((left, [, op, , right]) => ({
            type: "BinaryOp", op, left, right
        }), head);
    };
    var peg$f9 = function (head, tail) {
        return tail.reduce((left, [, op, , right]) => ({
            type: "BinaryOp", op, left, right
        }), head);
    };
    var peg$f10 = function (head, tail) {
        return tail.reduce((left, [, op, , right]) => ({
            type: "BinaryOp", op: "^", left, right
        }), head);
    };
    var peg$f11 = function (operand) {
        return { type: "UnaryOp", op: "-", operand };
    };
    var peg$f12 = function (expr) { return expr; };
    var peg$f13 = function (condition, then, else_) {
        return { type: "If", condition, then, "else": else_ ? else_[3] : null };
    };
    var peg$f14 = function (name) { return conditionalAggFns.includes(name.toUpperCase()); };
    var peg$f15 = function (name, value, condition) {
        return { type: "ConditionalAggregate", name: name.toUpperCase(), value, condition };
    };
    var peg$f16 = function (condition) {
        return { type: "CountIf", condition };
    };
    var peg$f17 = function (first, arg) {
        if (first.type !== "StringLiteral") {
            error('DATE_TRUNC first argument must be a string literal unit like "month"');
        }
        const unit = first.value.toLowerCase();
        if (!dateUnits.includes(unit)) {
            error('DATE_TRUNC unit must be one of: ' + dateUnits.join(', ') + '. Got: "' + first.value + '"');
        }
        return { type: "DateFn", name: "DATE_TRUNC", unit, args: [arg] };
    };
    var peg$f18 = function (name) { return name.toUpperCase() === 'DATE_ADD' || name.toUpperCase() === 'DATE_SUB'; };
    var peg$f19 = function (name, date, n, unitArg) {
        const fnName = name.toUpperCase();
        if (unitArg.type !== "StringLiteral") {
            error(fnName + ' third argument must be a string literal unit like "month"');
        }
        const unit = unitArg.value.toLowerCase();
        if (!dateUnits.includes(unit)) {
            error(fnName + ' unit must be one of: ' + dateUnits.join(', ') + '. Got: "' + unitArg.value + '"');
        }
        const nArg = fnName === 'DATE_SUB'
            ? { type: "UnaryOp", op: "-", operand: n }
            : n;
        return { type: "DateFn", name: "DATE_ADD", unit, args: [date, nArg] };
    };
    var peg$f20 = function (start, end, unitArg) {
        if (unitArg.type !== "StringLiteral") {
            error('DATE_DIFF third argument must be a string literal unit like "month"');
        }
        const unit = unitArg.value.toLowerCase();
        if (!dateUnits.includes(unit)) {
            error('DATE_DIFF unit must be one of: ' + dateUnits.join(', ') + '. Got: "' + unitArg.value + '"');
        }
        return { type: "DateFn", name: "DATE_DIFF", unit, args: [start, end] };
    };
    var peg$f21 = function (name) { return movingWindowFns.includes(name.toUpperCase()); };
    var peg$f22 = function (name, arg, n, rest) {
        const fnName = name.toUpperCase();
        if (n.type !== "NumberLiteral" || !Number.isInteger(n.value) || n.value <= 0) {
            error(fnName + ' second argument must be a positive integer literal');
        }
        const node = { type: "MovingWindowFn", name: fnName, arg, preceding: n.value, windowClause: null };
        for (const p of rest) {
            if (!node.windowClause)
                node.windowClause = { type: "WindowClause" };
            if (p.orderBy)
                node.windowClause.orderBy = p.orderBy;
            if (p.partitionBy)
                node.windowClause.partitionBy = p.partitionBy;
        }
        return node;
    };
    var peg$f23 = function (name) { return zeroArgFns.includes(name.toUpperCase()); };
    var peg$f24 = function (name) {
        return { type: "ZeroArgFn", name: name.toUpperCase() };
    };
    var peg$f25 = function (name) { return singleArgFns.includes(name.toUpperCase()); };
    var peg$f26 = function (name, arg) {
        return { type: "SingleArgFn", name: name.toUpperCase(), arg };
    };
    var peg$f27 = function (name) { return oneOrTwoArgFns.includes(name.toUpperCase()); };
    var peg$f28 = function (name, first, second) {
        const args = second ? [first, second[2]] : [first];
        return { type: "OneOrTwoArgFn", name: name.toUpperCase(), args };
    };
    var peg$f29 = function (name) { return zeroOrOneArgFns.includes(name.toUpperCase()); };
    var peg$f30 = function (name, arg) {
        return { type: "ZeroOrOneArgFn", name: name.toUpperCase(), arg: arg ?? null };
    };
    var peg$f31 = function (name) { return variadicFns.includes(name.toUpperCase()); };
    var peg$f32 = function (name, head, tail) {
        return { type: "VariadicFn", name: name.toUpperCase(), args: [head, ...tail.map(t => t[3])] };
    };
    var peg$f33 = function (name) { return windowFns.includes(name.toUpperCase()); };
    var peg$f34 = function (name, content) {
        const node = { type: "WindowFn", name: name.toUpperCase(), args: [], windowClause: null };
        if (content) {
            node.args = content.args;
            if (content.windowClause)
                node.windowClause = content.windowClause;
        }
        return node;
    };
    var peg$f35 = function () {
        error("IF requires a condition (e.g. A > 0) as its first argument");
    };
    var peg$f36 = function (name) { return conditionalAggFns.includes(name.toUpperCase()); };
    var peg$f37 = function (name) {
        error(name.toUpperCase() + " requires a condition (e.g. B > 0) as its second argument");
    };
    var peg$f38 = function () {
        error("COUNTIF requires a condition (e.g. A > 0) as its argument");
    };
    var peg$f39 = function (name) { return allFunctionNames.includes(name.toUpperCase()); };
    var peg$f40 = function (name) {
        error(name.toUpperCase() + " called with wrong number of arguments");
    };
    var peg$f41 = function (name) {
        error("Unknown function: " + name);
    };
    var peg$f42 = function (first, rest) {
        const wc = { type: "WindowClause" };
        const parts = [first, ...rest];
        for (const p of parts) {
            if (p.orderBy)
                wc.orderBy = p.orderBy;
            if (p.partitionBy)
                wc.partitionBy = p.partitionBy;
        }
        return { args: [], windowClause: wc };
    };
    var peg$f43 = function (head, tail) {
        const args = [head];
        let windowClause = undefined;
        for (const item of tail) {
            if (item._tag === 'arg')
                args.push(item.value);
            else {
                if (!windowClause)
                    windowClause = { type: "WindowClause" };
                if (item.orderBy)
                    windowClause.orderBy = item.orderBy;
                if (item.partitionBy)
                    windowClause.partitionBy = item.partitionBy;
            }
        }
        const result = { args };
        if (windowClause)
            result.windowClause = windowClause;
        return result;
    };
    var peg$f44 = function (col, dir) {
        return { _tag: 'window', orderBy: { column: col, direction: dir ? dir[1].toUpperCase() : undefined } };
    };
    var peg$f45 = function (col) {
        return { _tag: 'window', partitionBy: col };
    };
    var peg$f46 = function (expr) {
        return { _tag: 'arg', value: expr };
    };
    var peg$f47 = function (col, dir) {
        return { orderBy: { column: col, direction: dir ? dir[1].toUpperCase() : undefined } };
    };
    var peg$f48 = function (col) {
        return { partitionBy: col };
    };
    var peg$f49 = function (col, dir) {
        return { orderBy: { column: col, direction: dir ? dir[1].toUpperCase() : undefined } };
    };
    var peg$f50 = function (col) {
        return { partitionBy: col };
    };
    var peg$f51 = function (name) { return allFunctionNames.includes(name.toUpperCase()); };
    var peg$f52 = function (name) {
        return { type: "ColumnRef", name };
    };
    var peg$f53 = function (head, tail) { return head + tail.join(""); };
    var peg$f54 = function (digits) {
        const text = digits[0].join("") + (digits[1] ? "." + digits[1][1].join("") : "");
        return { type: "NumberLiteral", value: parseFloat(text) };
    };
    var peg$f55 = function (chars) { return { type: "StringLiteral", value: chars.join("") }; };
    var peg$f56 = function (chars) { return { type: "StringLiteral", value: chars.join("") }; };
    var peg$f57 = function () { return { type: "BooleanLiteral", value: true }; };
    var peg$f58 = function () { return { type: "BooleanLiteral", value: false }; };
    var peg$currPos = options.peg$currPos | 0;
    var peg$savedPos = peg$currPos;
    var peg$posDetailsCache = [{ line: 1, column: 1 }];
    var peg$maxFailPos = peg$currPos;
    var peg$maxFailExpected = options.peg$maxFailExpected || [];
    var peg$silentFails = options.peg$silentFails | 0;
    var peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        }
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function offset() {
        return peg$savedPos;
    }
    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos
        };
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== undefined
            ? location
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== undefined
            ? location
            : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return { type: "literal", text: text, ignoreCase: ignoreCase };
    }
    function peg$classExpectation(parts, inverted, ignoreCase) {
        return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
    }
    function peg$anyExpectation() {
        return { type: "any" };
    }
    function peg$endExpectation() {
        return { type: "end" };
    }
    function peg$otherExpectation(description) {
        return { type: "other", description: description };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos];
        var p;
        if (details) {
            return details;
        }
        else {
            if (pos >= peg$posDetailsCache.length) {
                p = peg$posDetailsCache.length - 1;
            }
            else {
                p = pos;
                while (!peg$posDetailsCache[--p]) { }
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while (p < pos) {
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                }
                else {
                    details.column++;
                }
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        var startPosDetails = peg$computePosDetails(startPos);
        var endPosDetails = peg$computePosDetails(endPos);
        var res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        if (offset && peg$source && (typeof peg$source.offset === "function")) {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) {
            return;
        }
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new peg$SyntaxError(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
    }
    function peg$parseFormula() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 61) {
            s1 = peg$c0;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e0);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$parseExpression();
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                peg$savedPos = s0;
                s0 = peg$f0(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseExpression() {
        var s0;
        s0 = peg$parseBooleanOr();
        if (s0 === peg$FAILED) {
            s0 = peg$parseAddition();
        }
        return s0;
    }
    function peg$parseBooleanOr() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseBooleanAnd();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            s5 = input.substr(peg$currPos, 2);
            if (s5.toLowerCase() === peg$c1) {
                peg$currPos += 2;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e1);
                }
            }
            if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                s7 = peg$parseBooleanAnd();
                if (s7 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                s5 = input.substr(peg$currPos, 2);
                if (s5.toLowerCase() === peg$c1) {
                    peg$currPos += 2;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e1);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    s7 = peg$parseBooleanAnd();
                    if (s7 !== peg$FAILED) {
                        s4 = [s4, s5, s6, s7];
                        s3 = s4;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f1(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseBooleanAnd() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseBooleanAtom();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            s5 = input.substr(peg$currPos, 3);
            if (s5.toLowerCase() === peg$c2) {
                peg$currPos += 3;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e2);
                }
            }
            if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                s7 = peg$parseBooleanAtom();
                if (s7 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                s5 = input.substr(peg$currPos, 3);
                if (s5.toLowerCase() === peg$c2) {
                    peg$currPos += 3;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e2);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    s7 = peg$parseBooleanAtom();
                    if (s7 !== peg$FAILED) {
                        s4 = [s4, s5, s6, s7];
                        s3 = s4;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f2(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseBooleanAtom() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 3);
        if (s1.toLowerCase() === peg$c3) {
            peg$currPos += 3;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e3);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$parseBooleanAtom();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f3(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$parseComparison();
            if (s0 === peg$FAILED) {
                s0 = peg$parseBooleanFn();
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 40) {
                        s1 = peg$c4;
                        peg$currPos++;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e4);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        s3 = peg$parseBooleanOr();
                        if (s3 !== peg$FAILED) {
                            s4 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s5 = peg$c5;
                                peg$currPos++;
                            }
                            else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e5);
                                }
                            }
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f4(s3);
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseBooleanLiteral();
                    }
                }
            }
        }
        return s0;
    }
    function peg$parseComparison() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseAddition();
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$parseComparisonOp();
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseAddition();
                if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f5(s1, s3, s5);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseComparisonOp() {
        var s0;
        if (input.substr(peg$currPos, 2) === peg$c6) {
            s0 = peg$c6;
            peg$currPos += 2;
        }
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e6);
            }
        }
        if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 2) === peg$c7) {
                s0 = peg$c7;
                peg$currPos += 2;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e7);
                }
            }
            if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 2) === peg$c8) {
                    s0 = peg$c8;
                    peg$currPos += 2;
                }
                else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e8);
                    }
                }
                if (s0 === peg$FAILED) {
                    s0 = input.charAt(peg$currPos);
                    if (peg$r0.test(s0)) {
                        peg$currPos++;
                    }
                    else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e9);
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parseBooleanFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f6(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 41) {
                            s8 = peg$c5;
                            peg$currPos++;
                        }
                        else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e5);
                            }
                        }
                        if (s8 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f7(s1, s6);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseAddition() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseMultiplication();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            s5 = input.charAt(peg$currPos);
            if (peg$r1.test(s5)) {
                peg$currPos++;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e10);
                }
            }
            if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                s7 = peg$parseMultiplication();
                if (s7 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                s5 = input.charAt(peg$currPos);
                if (peg$r1.test(s5)) {
                    peg$currPos++;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e10);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    s7 = peg$parseMultiplication();
                    if (s7 !== peg$FAILED) {
                        s4 = [s4, s5, s6, s7];
                        s3 = s4;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f8(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMultiplication() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parsePower();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            s5 = input.charAt(peg$currPos);
            if (peg$r2.test(s5)) {
                peg$currPos++;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e11);
                }
            }
            if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                s7 = peg$parsePower();
                if (s7 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                s5 = input.charAt(peg$currPos);
                if (peg$r2.test(s5)) {
                    peg$currPos++;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e11);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    s7 = peg$parsePower();
                    if (s7 !== peg$FAILED) {
                        s4 = [s4, s5, s6, s7];
                        s3 = s4;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f9(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsePower() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseUnaryExpr();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 94) {
                s5 = peg$c9;
                peg$currPos++;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e12);
                }
            }
            if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                s7 = peg$parseUnaryExpr();
                if (s7 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 94) {
                    s5 = peg$c9;
                    peg$currPos++;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e12);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    s7 = peg$parseUnaryExpr();
                    if (s7 !== peg$FAILED) {
                        s4 = [s4, s5, s6, s7];
                        s3 = s4;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            peg$savedPos = s0;
            s0 = peg$f10(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseUnaryExpr() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 45) {
            s1 = peg$c10;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e13);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = peg$parseUnaryExpr();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f11(s3);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$parsePrimary();
        }
        return s0;
    }
    function peg$parsePrimary() {
        var s0, s1, s2, s3, s4, s5;
        s0 = peg$parseIfExpr();
        if (s0 === peg$FAILED) {
            s0 = peg$parseConditionalAggregate();
            if (s0 === peg$FAILED) {
                s0 = peg$parseCountIf();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseDateTruncExpr();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseDateAddOrSubExpr();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseDateDiffExpr();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parseMovingWindowFn();
                                if (s0 === peg$FAILED) {
                                    s0 = peg$parseZeroArgFn();
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$parseSingleArgFn();
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$parseOneOrTwoArgFn();
                                            if (s0 === peg$FAILED) {
                                                s0 = peg$parseZeroOrOneArgFn();
                                                if (s0 === peg$FAILED) {
                                                    s0 = peg$parseVariadicFn();
                                                    if (s0 === peg$FAILED) {
                                                        s0 = peg$parseWindowFn();
                                                        if (s0 === peg$FAILED) {
                                                            s0 = peg$parseInvalidFn();
                                                            if (s0 === peg$FAILED) {
                                                                s0 = peg$currPos;
                                                                if (input.charCodeAt(peg$currPos) === 40) {
                                                                    s1 = peg$c4;
                                                                    peg$currPos++;
                                                                }
                                                                else {
                                                                    s1 = peg$FAILED;
                                                                    if (peg$silentFails === 0) {
                                                                        peg$fail(peg$e4);
                                                                    }
                                                                }
                                                                if (s1 !== peg$FAILED) {
                                                                    s2 = peg$parse_();
                                                                    s3 = peg$parseExpression();
                                                                    if (s3 !== peg$FAILED) {
                                                                        s4 = peg$parse_();
                                                                        if (input.charCodeAt(peg$currPos) === 41) {
                                                                            s5 = peg$c5;
                                                                            peg$currPos++;
                                                                        }
                                                                        else {
                                                                            s5 = peg$FAILED;
                                                                            if (peg$silentFails === 0) {
                                                                                peg$fail(peg$e5);
                                                                            }
                                                                        }
                                                                        if (s5 !== peg$FAILED) {
                                                                            peg$savedPos = s0;
                                                                            s0 = peg$f12(s3);
                                                                        }
                                                                        else {
                                                                            peg$currPos = s0;
                                                                            s0 = peg$FAILED;
                                                                        }
                                                                    }
                                                                    else {
                                                                        peg$currPos = s0;
                                                                        s0 = peg$FAILED;
                                                                    }
                                                                }
                                                                else {
                                                                    peg$currPos = s0;
                                                                    s0 = peg$FAILED;
                                                                }
                                                                if (s0 === peg$FAILED) {
                                                                    s0 = peg$parseNumberLiteral();
                                                                    if (s0 === peg$FAILED) {
                                                                        s0 = peg$parseStringLiteral();
                                                                        if (s0 === peg$FAILED) {
                                                                            s0 = peg$parseColumnRef();
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parseIfExpr() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 2);
        if (s1.toLowerCase() === peg$c11) {
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e14);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c4;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseBooleanOr();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s7 = peg$c12;
                        peg$currPos++;
                    }
                    else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e15);
                        }
                    }
                    if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();
                        s9 = peg$parseExpression();
                        if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            s11 = peg$currPos;
                            s12 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s13 = peg$c12;
                                peg$currPos++;
                            }
                            else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e15);
                                }
                            }
                            if (s13 !== peg$FAILED) {
                                s14 = peg$parse_();
                                s15 = peg$parseExpression();
                                if (s15 !== peg$FAILED) {
                                    s12 = [s12, s13, s14, s15];
                                    s11 = s12;
                                }
                                else {
                                    peg$currPos = s11;
                                    s11 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s11;
                                s11 = peg$FAILED;
                            }
                            if (s11 === peg$FAILED) {
                                s11 = null;
                            }
                            s12 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s13 = peg$c5;
                                peg$currPos++;
                            }
                            else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e5);
                                }
                            }
                            if (s13 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f13(s5, s9, s11);
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseConditionalAggregate() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f14(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s8 = peg$c12;
                            peg$currPos++;
                        }
                        else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e15);
                            }
                        }
                        if (s8 !== peg$FAILED) {
                            s9 = peg$parse_();
                            s10 = peg$parseBooleanOr();
                            if (s10 !== peg$FAILED) {
                                s11 = peg$parse_();
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s12 = peg$c5;
                                    peg$currPos++;
                                }
                                else {
                                    s12 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e5);
                                    }
                                }
                                if (s12 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s0 = peg$f15(s1, s6, s10);
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseCountIf() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 7);
        if (s1.toLowerCase() === peg$c13) {
            peg$currPos += 7;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e16);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c4;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseBooleanOr();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c5;
                        peg$currPos++;
                    }
                    else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e5);
                        }
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f16(s5);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseDateTruncExpr() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 10);
        if (s1.toLowerCase() === peg$c14) {
            peg$currPos += 10;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e17);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c4;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseExpression();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s7 = peg$c12;
                        peg$currPos++;
                    }
                    else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e15);
                        }
                    }
                    if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();
                        s9 = peg$parseExpression();
                        if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s11 = peg$c5;
                                peg$currPos++;
                            }
                            else {
                                s11 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e5);
                                }
                            }
                            if (s11 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f17(s5, s9);
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseDateAddOrSubExpr() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f18(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s8 = peg$c12;
                            peg$currPos++;
                        }
                        else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e15);
                            }
                        }
                        if (s8 !== peg$FAILED) {
                            s9 = peg$parse_();
                            s10 = peg$parseExpression();
                            if (s10 !== peg$FAILED) {
                                s11 = peg$parse_();
                                if (input.charCodeAt(peg$currPos) === 44) {
                                    s12 = peg$c12;
                                    peg$currPos++;
                                }
                                else {
                                    s12 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e15);
                                    }
                                }
                                if (s12 !== peg$FAILED) {
                                    s13 = peg$parse_();
                                    s14 = peg$parseExpression();
                                    if (s14 !== peg$FAILED) {
                                        s15 = peg$parse_();
                                        if (input.charCodeAt(peg$currPos) === 41) {
                                            s16 = peg$c5;
                                            peg$currPos++;
                                        }
                                        else {
                                            s16 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$e5);
                                            }
                                        }
                                        if (s16 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s0 = peg$f19(s1, s6, s10, s14);
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseDateDiffExpr() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 9);
        if (s1.toLowerCase() === peg$c15) {
            peg$currPos += 9;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e18);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c4;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseExpression();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s7 = peg$c12;
                        peg$currPos++;
                    }
                    else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e15);
                        }
                    }
                    if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();
                        s9 = peg$parseExpression();
                        if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s11 = peg$c12;
                                peg$currPos++;
                            }
                            else {
                                s11 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e15);
                                }
                            }
                            if (s11 !== peg$FAILED) {
                                s12 = peg$parse_();
                                s13 = peg$parseExpression();
                                if (s13 !== peg$FAILED) {
                                    s14 = peg$parse_();
                                    if (input.charCodeAt(peg$currPos) === 41) {
                                        s15 = peg$c5;
                                        peg$currPos++;
                                    }
                                    else {
                                        s15 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$e5);
                                        }
                                    }
                                    if (s15 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s0 = peg$f20(s5, s9, s13);
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseMovingWindowFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f21(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s8 = peg$c12;
                            peg$currPos++;
                        }
                        else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e15);
                            }
                        }
                        if (s8 !== peg$FAILED) {
                            s9 = peg$parse_();
                            s10 = peg$parseExpression();
                            if (s10 !== peg$FAILED) {
                                s11 = [];
                                s12 = peg$parseWindowClausePart();
                                while (s12 !== peg$FAILED) {
                                    s11.push(s12);
                                    s12 = peg$parseWindowClausePart();
                                }
                                s12 = peg$parse_();
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s13 = peg$c5;
                                    peg$currPos++;
                                }
                                else {
                                    s13 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e5);
                                    }
                                }
                                if (s13 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s0 = peg$f22(s1, s6, s10, s11);
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseZeroArgFn() {
        var s0, s1, s2, s3, s4, s5, s6;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f23(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s6 = peg$c5;
                        peg$currPos++;
                    }
                    else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e5);
                        }
                    }
                    if (s6 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f24(s1);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseSingleArgFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f25(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 41) {
                            s8 = peg$c5;
                            peg$currPos++;
                        }
                        else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e5);
                            }
                        }
                        if (s8 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f26(s1, s6);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseOneOrTwoArgFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f27(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        s8 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s9 = peg$c12;
                            peg$currPos++;
                        }
                        else {
                            s9 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e15);
                            }
                        }
                        if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            s11 = peg$parseExpression();
                            if (s11 !== peg$FAILED) {
                                s9 = [s9, s10, s11];
                                s8 = s9;
                            }
                            else {
                                peg$currPos = s8;
                                s8 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s8;
                            s8 = peg$FAILED;
                        }
                        if (s8 === peg$FAILED) {
                            s8 = null;
                        }
                        s9 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 41) {
                            s10 = peg$c5;
                            peg$currPos++;
                        }
                        else {
                            s10 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e5);
                            }
                        }
                        if (s10 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f28(s1, s6, s8);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseZeroOrOneArgFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f29(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 === peg$FAILED) {
                        s6 = null;
                    }
                    s7 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c5;
                        peg$currPos++;
                    }
                    else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e5);
                        }
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f30(s1, s6);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseVariadicFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f31(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseExpression();
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        s8 = peg$currPos;
                        s9 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s10 = peg$c12;
                            peg$currPos++;
                        }
                        else {
                            s10 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e15);
                            }
                        }
                        if (s10 !== peg$FAILED) {
                            s11 = peg$parse_();
                            s12 = peg$parseExpression();
                            if (s12 !== peg$FAILED) {
                                s9 = [s9, s10, s11, s12];
                                s8 = s9;
                            }
                            else {
                                peg$currPos = s8;
                                s8 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s8;
                            s8 = peg$FAILED;
                        }
                        while (s8 !== peg$FAILED) {
                            s7.push(s8);
                            s8 = peg$currPos;
                            s9 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s10 = peg$c12;
                                peg$currPos++;
                            }
                            else {
                                s10 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e15);
                                }
                            }
                            if (s10 !== peg$FAILED) {
                                s11 = peg$parse_();
                                s12 = peg$parseExpression();
                                if (s12 !== peg$FAILED) {
                                    s9 = [s9, s10, s11, s12];
                                    s8 = s9;
                                }
                                else {
                                    peg$currPos = s8;
                                    s8 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s8;
                                s8 = peg$FAILED;
                            }
                        }
                        s8 = peg$parse_();
                        if (input.charCodeAt(peg$currPos) === 41) {
                            s9 = peg$c5;
                            peg$currPos++;
                        }
                        else {
                            s9 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e5);
                            }
                        }
                        if (s9 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f32(s1, s6, s7);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseWindowFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f33(s1);
            if (s2) {
                s2 = undefined;
            }
            else {
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 40) {
                    s4 = peg$c4;
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e4);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = peg$parseWindowFnContent();
                    if (s6 === peg$FAILED) {
                        s6 = null;
                    }
                    s7 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c5;
                        peg$currPos++;
                    }
                    else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e5);
                        }
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f34(s1, s6);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseInvalidFn() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 2);
        if (s1.toLowerCase() === peg$c11) {
            peg$currPos += 2;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e14);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c4;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e4);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseExpression();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s7 = peg$c12;
                        peg$currPos++;
                    }
                    else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e15);
                        }
                    }
                    if (s7 !== peg$FAILED) {
                        s8 = peg$parse_();
                        s9 = peg$parseExpression();
                        if (s9 !== peg$FAILED) {
                            s10 = peg$parse_();
                            s11 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s12 = peg$c12;
                                peg$currPos++;
                            }
                            else {
                                s12 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e15);
                                }
                            }
                            if (s12 !== peg$FAILED) {
                                s13 = peg$parse_();
                                s14 = peg$parseExpression();
                                if (s14 !== peg$FAILED) {
                                    s12 = [s12, s13, s14];
                                    s11 = s12;
                                }
                                else {
                                    peg$currPos = s11;
                                    s11 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s11;
                                s11 = peg$FAILED;
                            }
                            if (s11 === peg$FAILED) {
                                s11 = null;
                            }
                            s12 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s13 = peg$c5;
                                peg$currPos++;
                            }
                            else {
                                s13 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e5);
                                }
                            }
                            if (s13 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f35();
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseIdentifier();
            if (s1 !== peg$FAILED) {
                peg$savedPos = peg$currPos;
                s2 = peg$f36(s1);
                if (s2) {
                    s2 = undefined;
                }
                else {
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 40) {
                        s4 = peg$c4;
                        peg$currPos++;
                    }
                    else {
                        s4 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e4);
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parse_();
                        s6 = peg$parseExpression();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s8 = peg$c12;
                                peg$currPos++;
                            }
                            else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e15);
                                }
                            }
                            if (s8 !== peg$FAILED) {
                                s9 = peg$parse_();
                                s10 = peg$parseExpression();
                                if (s10 !== peg$FAILED) {
                                    s11 = peg$parse_();
                                    if (input.charCodeAt(peg$currPos) === 41) {
                                        s12 = peg$c5;
                                        peg$currPos++;
                                    }
                                    else {
                                        s12 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$e5);
                                        }
                                    }
                                    if (s12 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s0 = peg$f37(s1);
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = input.substr(peg$currPos, 7);
                if (s1.toLowerCase() === peg$c13) {
                    peg$currPos += 7;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e16);
                    }
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parse_();
                    if (input.charCodeAt(peg$currPos) === 40) {
                        s3 = peg$c4;
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e4);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        s5 = peg$parseExpression();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s7 = peg$c5;
                                peg$currPos++;
                            }
                            else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e5);
                                }
                            }
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f38();
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parseIdentifier();
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = peg$currPos;
                        s2 = peg$f39(s1);
                        if (s2) {
                            s2 = undefined;
                        }
                        else {
                            s2 = peg$FAILED;
                        }
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 40) {
                                s4 = peg$c4;
                                peg$currPos++;
                            }
                            else {
                                s4 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e4);
                                }
                            }
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parse_();
                                s6 = peg$parseArgListPermissive();
                                if (s6 === peg$FAILED) {
                                    s6 = null;
                                }
                                s7 = peg$parse_();
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s8 = peg$c5;
                                    peg$currPos++;
                                }
                                else {
                                    s8 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e5);
                                    }
                                }
                                if (s8 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s0 = peg$f40(s1);
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseIdentifier();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parse_();
                            if (input.charCodeAt(peg$currPos) === 40) {
                                s3 = peg$c4;
                                peg$currPos++;
                            }
                            else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e4);
                                }
                            }
                            if (s3 !== peg$FAILED) {
                                s4 = peg$parse_();
                                s5 = peg$parseArgListPermissive();
                                if (s5 === peg$FAILED) {
                                    s5 = null;
                                }
                                s6 = peg$parse_();
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s7 = peg$c5;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$e5);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s0 = peg$f41(s1);
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                }
            }
        }
        return s0;
    }
    function peg$parseArgListPermissive() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        s1 = peg$parseExpression();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c12;
                peg$currPos++;
            }
            else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e15);
                }
            }
            if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                s7 = peg$parseExpression();
                if (s7 !== peg$FAILED) {
                    s4 = [s4, s5, s6, s7];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 44) {
                    s5 = peg$c12;
                    peg$currPos++;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e15);
                    }
                }
                if (s5 !== peg$FAILED) {
                    s6 = peg$parse_();
                    s7 = peg$parseExpression();
                    if (s7 !== peg$FAILED) {
                        s4 = [s4, s5, s6, s7];
                        s3 = s4;
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            s1 = [s1, s2];
            s0 = s1;
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseWindowFnContent() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseWindowClausePartFirst();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseWindowClausePart();
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parseWindowClausePart();
            }
            peg$savedPos = s0;
            s0 = peg$f42(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseExpression();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseWindowFnContentTail();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parseWindowFnContentTail();
                }
                peg$savedPos = s0;
                s0 = peg$f43(s1, s2);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseWindowFnContentTail() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (input.charCodeAt(peg$currPos) === 44) {
            s2 = peg$c12;
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e15);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parse_();
            s4 = input.substr(peg$currPos, 5);
            if (s4.toLowerCase() === peg$c16) {
                peg$currPos += 5;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e19);
                }
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parse_();
                s6 = input.substr(peg$currPos, 2);
                if (s6.toLowerCase() === peg$c17) {
                    peg$currPos += 2;
                }
                else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e20);
                    }
                }
                if (s6 !== peg$FAILED) {
                    s7 = peg$parse_();
                    s8 = peg$parseExpression();
                    if (s8 !== peg$FAILED) {
                        s9 = peg$currPos;
                        s10 = peg$parse_();
                        s11 = input.substr(peg$currPos, 3);
                        if (s11.toLowerCase() === peg$c18) {
                            peg$currPos += 3;
                        }
                        else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e21);
                            }
                        }
                        if (s11 === peg$FAILED) {
                            s11 = input.substr(peg$currPos, 4);
                            if (s11.toLowerCase() === peg$c19) {
                                peg$currPos += 4;
                            }
                            else {
                                s11 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e22);
                                }
                            }
                        }
                        if (s11 !== peg$FAILED) {
                            s10 = [s10, s11];
                            s9 = s10;
                        }
                        else {
                            peg$currPos = s9;
                            s9 = peg$FAILED;
                        }
                        if (s9 === peg$FAILED) {
                            s9 = null;
                        }
                        peg$savedPos = s0;
                        s0 = peg$f44(s8, s9);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s2 = peg$c12;
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e15);
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                s4 = input.substr(peg$currPos, 9);
                if (s4.toLowerCase() === peg$c20) {
                    peg$currPos += 9;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e23);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = input.substr(peg$currPos, 2);
                    if (s6.toLowerCase() === peg$c17) {
                        peg$currPos += 2;
                    }
                    else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e20);
                        }
                    }
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        s8 = peg$parseExpression();
                        if (s8 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f45(s8);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parse_();
                if (input.charCodeAt(peg$currPos) === 44) {
                    s2 = peg$c12;
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e15);
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    s4 = peg$parseExpression();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f46(s4);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
        }
        return s0;
    }
    function peg$parseWindowClausePartFirst() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 5);
        if (s1.toLowerCase() === peg$c16) {
            peg$currPos += 5;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e19);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parse_();
            s3 = input.substr(peg$currPos, 2);
            if (s3.toLowerCase() === peg$c17) {
                peg$currPos += 2;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e20);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = peg$parse_();
                s5 = peg$parseExpression();
                if (s5 !== peg$FAILED) {
                    s6 = peg$currPos;
                    s7 = peg$parse_();
                    s8 = input.substr(peg$currPos, 3);
                    if (s8.toLowerCase() === peg$c18) {
                        peg$currPos += 3;
                    }
                    else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e21);
                        }
                    }
                    if (s8 === peg$FAILED) {
                        s8 = input.substr(peg$currPos, 4);
                        if (s8.toLowerCase() === peg$c19) {
                            peg$currPos += 4;
                        }
                        else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e22);
                            }
                        }
                    }
                    if (s8 !== peg$FAILED) {
                        s7 = [s7, s8];
                        s6 = s7;
                    }
                    else {
                        peg$currPos = s6;
                        s6 = peg$FAILED;
                    }
                    if (s6 === peg$FAILED) {
                        s6 = null;
                    }
                    peg$savedPos = s0;
                    s0 = peg$f47(s5, s6);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = input.substr(peg$currPos, 9);
            if (s1.toLowerCase() === peg$c20) {
                peg$currPos += 9;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e23);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                s3 = input.substr(peg$currPos, 2);
                if (s3.toLowerCase() === peg$c17) {
                    peg$currPos += 2;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e20);
                    }
                }
                if (s3 !== peg$FAILED) {
                    s4 = peg$parse_();
                    s5 = peg$parseExpression();
                    if (s5 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f48(s5);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseWindowClausePart() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
        s0 = peg$currPos;
        s1 = peg$parse_();
        if (input.charCodeAt(peg$currPos) === 44) {
            s2 = peg$c12;
            peg$currPos++;
        }
        else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e15);
            }
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parse_();
            s4 = input.substr(peg$currPos, 5);
            if (s4.toLowerCase() === peg$c16) {
                peg$currPos += 5;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e19);
                }
            }
            if (s4 !== peg$FAILED) {
                s5 = peg$parse_();
                s6 = input.substr(peg$currPos, 2);
                if (s6.toLowerCase() === peg$c17) {
                    peg$currPos += 2;
                }
                else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e20);
                    }
                }
                if (s6 !== peg$FAILED) {
                    s7 = peg$parse_();
                    s8 = peg$parseExpression();
                    if (s8 !== peg$FAILED) {
                        s9 = peg$currPos;
                        s10 = peg$parse_();
                        s11 = input.substr(peg$currPos, 3);
                        if (s11.toLowerCase() === peg$c18) {
                            peg$currPos += 3;
                        }
                        else {
                            s11 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e21);
                            }
                        }
                        if (s11 === peg$FAILED) {
                            s11 = input.substr(peg$currPos, 4);
                            if (s11.toLowerCase() === peg$c19) {
                                peg$currPos += 4;
                            }
                            else {
                                s11 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$e22);
                                }
                            }
                        }
                        if (s11 !== peg$FAILED) {
                            s10 = [s10, s11];
                            s9 = s10;
                        }
                        else {
                            peg$currPos = s9;
                            s9 = peg$FAILED;
                        }
                        if (s9 === peg$FAILED) {
                            s9 = null;
                        }
                        peg$savedPos = s0;
                        s0 = peg$f49(s8, s9);
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (input.charCodeAt(peg$currPos) === 44) {
                s2 = peg$c12;
                peg$currPos++;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e15);
                }
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parse_();
                s4 = input.substr(peg$currPos, 9);
                if (s4.toLowerCase() === peg$c20) {
                    peg$currPos += 9;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e23);
                    }
                }
                if (s4 !== peg$FAILED) {
                    s5 = peg$parse_();
                    s6 = input.substr(peg$currPos, 2);
                    if (s6.toLowerCase() === peg$c17) {
                        peg$currPos += 2;
                    }
                    else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e20);
                        }
                    }
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parse_();
                        s8 = peg$parseExpression();
                        if (s8 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s0 = peg$f50(s8);
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseColumnRef() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseIdentifier();
        if (s1 !== peg$FAILED) {
            peg$savedPos = peg$currPos;
            s2 = peg$f51(s1);
            if (s2) {
                s2 = peg$FAILED;
            }
            else {
                s2 = undefined;
            }
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f52(s1);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseIdentifier() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r3.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e24);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = input.charAt(peg$currPos);
            if (peg$r4.test(s3)) {
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e25);
                }
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = input.charAt(peg$currPos);
                if (peg$r4.test(s3)) {
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e25);
                    }
                }
            }
            peg$savedPos = s0;
            s0 = peg$f53(s1, s2);
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseNumberLiteral() {
        var s0, s1, s2, s3, s4, s5, s6;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r5.test(s3)) {
            peg$currPos++;
        }
        else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e26);
            }
        }
        if (s3 !== peg$FAILED) {
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = input.charAt(peg$currPos);
                if (peg$r5.test(s3)) {
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e26);
                    }
                }
            }
        }
        else {
            s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
                s4 = peg$c21;
                peg$currPos++;
            }
            else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e27);
                }
            }
            if (s4 !== peg$FAILED) {
                s5 = [];
                s6 = input.charAt(peg$currPos);
                if (peg$r5.test(s6)) {
                    peg$currPos++;
                }
                else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e26);
                    }
                }
                if (s6 !== peg$FAILED) {
                    while (s6 !== peg$FAILED) {
                        s5.push(s6);
                        s6 = input.charAt(peg$currPos);
                        if (peg$r5.test(s6)) {
                            peg$currPos++;
                        }
                        else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$e26);
                            }
                        }
                    }
                }
                else {
                    s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                    s4 = [s4, s5];
                    s3 = s4;
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s3;
                s3 = peg$FAILED;
            }
            if (s3 === peg$FAILED) {
                s3 = null;
            }
            s2 = [s2, s3];
            s1 = s2;
        }
        else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f54(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parseStringLiteral() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 34) {
            s1 = peg$c22;
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e28);
            }
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = input.charAt(peg$currPos);
            if (peg$r6.test(s3)) {
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e29);
                }
            }
            while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = input.charAt(peg$currPos);
                if (peg$r6.test(s3)) {
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e29);
                    }
                }
            }
            if (input.charCodeAt(peg$currPos) === 34) {
                s3 = peg$c22;
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e28);
                }
            }
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f55(s2);
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
                s1 = peg$c23;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e30);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = input.charAt(peg$currPos);
                if (peg$r7.test(s3)) {
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e31);
                    }
                }
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = input.charAt(peg$currPos);
                    if (peg$r7.test(s3)) {
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$e31);
                        }
                    }
                }
                if (input.charCodeAt(peg$currPos) === 39) {
                    s3 = peg$c23;
                    peg$currPos++;
                }
                else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$e30);
                    }
                }
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f56(s2);
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parseBooleanLiteral() {
        var s0, s1;
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 4);
        if (s1.toLowerCase() === peg$c24) {
            peg$currPos += 4;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e32);
            }
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f57();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = input.substr(peg$currPos, 5);
            if (s1.toLowerCase() === peg$c25) {
                peg$currPos += 5;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e33);
                }
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f58();
            }
            s0 = s1;
        }
        return s0;
    }
    function peg$parse_() {
        var s0, s1;
        peg$silentFails++;
        s0 = [];
        s1 = input.charAt(peg$currPos);
        if (peg$r8.test(s1)) {
            peg$currPos++;
        }
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
                peg$fail(peg$e35);
            }
        }
        while (s1 !== peg$FAILED) {
            s0.push(s1);
            s1 = input.charAt(peg$currPos);
            if (peg$r8.test(s1)) {
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$e35);
                }
            }
        }
        peg$silentFails--;
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
            peg$fail(peg$e34);
        }
        return s0;
    }
    const zeroArgFns = options.zeroArgFns;
    const singleArgFns = options.singleArgFns;
    const oneOrTwoArgFns = options.oneOrTwoArgFns;
    const zeroOrOneArgFns = options.zeroOrOneArgFns;
    const variadicFns = options.variadicFns;
    const windowFns = options.windowFns;
    const movingWindowFns = options.movingWindowFns;
    const conditionalAggFns = options.conditionalAggFns;
    const dateFns = options.dateFns;
    const dateUnits = options.dateUnits;
    const allFunctionNames = options.allFunctionNames;
    const booleanFns = options.booleanFns;
    peg$result = peg$startRuleFunction();
    if (options.peg$library) {
        return /** @type {any} */ ({
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos
        });
    }
    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
        return peg$result;
    }
    else {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
            peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length
            ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
            : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
}
const peg$allowedStartRules = [
    "Formula"
];
exports.StartRules = peg$allowedStartRules;
//# sourceMappingURL=parser.js.map